"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBucketLifecycleConfigurationInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        }
    }
};
//# sourceMappingURL=GetBucketLifecycleConfigurationInput.js.map